@if (isEditMode) {
  <div class="table-content" title="{{cellValue}}">
    <input class="form-control" [(ngModel)]="cellValue" (blur)="blurAction()">
  </div>
}

@if (!isEditMode) {
  <div class="table-content" title="{{cellValue}}">
    <input autocomplete="off" type="text" class="form-control fn-input" [(ngModel)]="cellValue" fnCurrencyDirective maxLength="10" disabled='disabled' />
  </div>
}